import { render } from "./Scenario3D.vue?vue&type=template&id=148aec97"
import script from "./Scenario3D.js?vue&type=script&lang=js"
export * from "./Scenario3D.js?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__